import { render } from "./ProductOverview.vue?vue&type=template&id=2312cb66"
import script from "./ProductOverview.vue?vue&type=script&lang=js"
export * from "./ProductOverview.vue?vue&type=script&lang=js"

import "./ProductOverview.vue?vue&type=style&index=0&id=2312cb66&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__